import { useSnackbar } from 'notistack';
import { useEffect, useRef } from 'react';
import useApiErrorMessageGetter from './useApiErrorMessage';

/**
 * Simple hook to notify of errors received from "useQuery" hooks.
 * It expects the provided array to not change its length during its usage lifetime.
 */
const useQueryErrorNotifier = (handledErrors: Array<Error | null>) => {
  const getApiErrorMessage = useApiErrorMessageGetter();

  const notifiedErrors = useRef<Record<number, Error | null>>({});

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    handledErrors.forEach((error, index) => {
      if (error && notifiedErrors.current[index] !== error) {
        enqueueSnackbar({
          variant: 'error',
          message: getApiErrorMessage(error),
        });
      }
      // Always update to the latest value of the specific index
      notifiedErrors.current[index] = error;
    });
    // It uses the handled errors as the dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enqueueSnackbar, ...handledErrors]);
};

export default useQueryErrorNotifier;
